import styled from "styled-components";
import { style } from "../style";

export const ItemizedSpacer = styled.div<{ $dashed?: boolean }>`
  all: unset;
  box-sizing: border-box;

  width: 100%;
  height: 0px;

  border-top: 1px ${(props) => (props.$dashed ? "dashed" : "solid")} ${style.colors.grey.primary};
`;
